var map = {
	"./media/MediaPlayer": [
		26,
		9,
		2,
		1
	],
	"./media/MediaPlayer.jsx": [
		26,
		9,
		2,
		1
	],
	"./ui/Slider": [
		2,
		9
	],
	"./ui/Slider/": [
		2,
		9
	],
	"./ui/Slider/component.scss": [
		52,
		7,
		5
	],
	"./ui/Slider/index": [
		2,
		9
	],
	"./ui/Slider/index.js": [
		2,
		9
	],
	"./ui/Tabs": [
		5,
		9,
		0
	],
	"./ui/Tabs/": [
		5,
		9,
		0
	],
	"./ui/Tabs/Tabs.scss": [
		51,
		7,
		6
	],
	"./ui/Tabs/index": [
		5,
		9,
		0
	],
	"./ui/Tabs/index.js": [
		5,
		9,
		0
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 29;
module.exports = webpackAsyncContext;